import { createContext, useContext } from 'react';

export interface RentalContextType {
  displayCurrency: string;
  keywordTerms: string[];
}

export const RentalContext = createContext<RentalContextType | undefined>(undefined);

export function useRentalContext() {
  const ctx = useContext(RentalContext);
  if (!ctx) throw new Error("useRentalContext must be used within a RentalProvider");
  return ctx;
}
